var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union (Stroke)",
    d: "M8.09656 13.9404L8.09221 13.9381L8.07711 13.9299C8.06425 13.9229 8.04586 13.9128 8.0223 13.8997C7.9752 13.8734 7.90741 13.8349 7.82189 13.7846C7.65092 13.684 7.4087 13.5359 7.11895 13.3433C6.54041 12.9587 5.7674 12.3934 4.99232 11.6709C3.45846 10.241 1.83325 8.11673 1.83325 5.5C1.83325 3.54796 3.47565 2 5.45825 2C6.62417 2 7.66813 2.53273 8.33325 3.36773C8.99837 2.53273 10.0423 2 11.2083 2C13.1909 2 14.8333 3.54796 14.8333 5.5C14.8333 8.11673 13.208 10.241 11.6742 11.6709C10.8991 12.3934 10.1261 12.9587 9.54755 13.3433C9.2578 13.5359 9.01559 13.684 8.84461 13.7846C8.75909 13.8349 8.69131 13.8734 8.6442 13.8997C8.62065 13.9128 8.60225 13.9229 8.58939 13.9299L8.57429 13.9381L8.56994 13.9404L8.5681 13.9414C8.42146 14.0193 8.24505 14.0193 8.0984 13.9414L8.09656 13.9404Z",
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeart);
export default __webpack_public_path__ + "static/media/ic_heart.878537db56794bd581bff9eabae3c302.svg";
export { ForwardRef as ReactComponent };